import React, { Component } from 'react';
import * as d3 from 'd3';
import './timeline.css';

class DTimeline extends Component {
	constructor(props) {
		super(props);

		this.chart = React.createRef();
		
		this.abstract = this.abstract.bind( this );
		this.dateFormat = this.dateFormat.bind(this);
		this.draw = this.draw.bind( this );
		this.setMax = this.setMax.bind( this );
		this.viewbox = this.viewbox.bind( this );
		this.writeMarkup = this.writeMarkup.bind( this );
				
		this.positionData = {};
				
		this.state = {
			"activity": {},
			"articleHeight": 110,
			"articleWidth": 175,
			"articles": [],
			"borders": 40,
			"debug": [],
			"enabled": false,
			"milestones": [],
			"max_values": {
				"activity": -1,
				"popularity": -1
			},
			"min_width": 400,
			"oneDay": 60 * 60 * 24,
			"parties": {
				"destra":"Destra",
				"centro-destra": "C. Destra",
				"m5s":"Mov. 5 Stelle",
				"centro-sinistra":"C. Sinistra",
				"sinistra":"Sinistra"
			},
			"paths": {
				"date_lines": [],
				"curves": []
			},
			"size": {
				"h": 1600,
				"w": 800
			}
		}
	}
	
	componentDidMount() {
		this.setState(
			{
				activity: this.props.Data.data.history.activity,
				articles: this.props.Data.data.history.articles
			},
			() => {
				this.setMax();
				window.addEventListener( 'resize', this.viewbox, false );
				this.viewbox();
			}
		);
	}
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}
	
	abstract( text, maxLength ) {
		if ( maxLength === undefined ) {
			maxLength = 75;
		}
		if ( text.length <= maxLength ) {
			return text;
		}
		text = text.substr(0, maxLength);
		return text.substr( 0, Math.min( text.length, text.lastIndexOf(" ") ) ) + '…';
	}
	
	dateFormat(timestamp, ht) {
		const d = new Date( timestamp * 1000 );
		const gg = "00" + d.getDate();
		const mm = "00" + (d.getMonth()+1);
		const YY = "00" + d.getFullYear();
		const hh = "00" + d.getHours();
		const nn = "00" + d.getMinutes();
		return gg.substr(gg.length - 2) + '/' + mm.substr(mm.length - 2) + '/' + YY.substr(YY.length - 4) + ( ( ht === true ) ? '' : ' ' + hh.substr(hh.length - 2) + ':' + nn.substr(nn.length - 2) );
	}
	
	draw() {
		let news = [];
		let lines = [];
		let curves = [];
		let debug = [];
		let parties =  this.state.parties;
		
		if ( this.state.articles.length > 0 ) {
			var minY = ( parseInt( this.state.articles[ 0 ].date_published_timestamp, 10 ) + this.state.oneDay ),
				maxY = ( parseInt( this.state.articles[ ( this.state.articles.length - 1 ) ].date_published_timestamp, 10 ) - this.state.oneDay ),
				maxXActivity = this.state.max_values.activity,
				maxXPopularity = this.state.max_values.popularity,
				
				scaleY = d3.scaleLinear()
		            .domain( [  minY,  maxY ] )
		            .range( [ 0, ( this.state.size.h ) ] );
	        	
	        for( let i=0, l =this.state.articles.length; i<l; i++ ) {
		        let y = scaleY( this.state.articles[i].date_published_timestamp );
		        // Articles' list
		        news[i] = this.state.articles[i];
		        news[i].top = y - 6;
		        // SVG lines 
		        lines.push(
			        {
				        "y": y
			        }
		        )
	        }
		}
		if ( Object.keys( this.state.activity ).length > 0 && this.state.articles.length > 0 ) {
			// Charts
			let activity = this.state.activity;
			let availableSpace = this.state.size.w - this.state.articleWidth - this.state.borders;
			let slots = availableSpace / Object.keys(activity).length;
			let baseX = this.state.articleWidth + ( this.state.borders / 2 );
			
			// Boundaries
			Object.keys( activity ).forEach(
				function( key, index ) {
					let max = ( baseX + ( slots * index)  );
					let boundaries = {
						"max": max - ( slots / 3 ),
						"center": max + ( slots / 2 ),
						"min": max + slots + ( slots / 3 )
					}
					
					let scaleXActivity = d3.scaleLinear()
						.domain( [ 0, maxXActivity ] )
						.range( [ boundaries.center, boundaries.max ] );
					
					let scaleXPopularity = d3.scaleLinear()
						.domain( [ 0, maxXPopularity ] )
						.range( [ boundaries.center, boundaries.max ] );
					
					let points = [
						{
							"xAct": scaleXActivity( 0 ),
							"xPop": scaleXPopularity( 0 ),
							"y": scaleY( maxY )
						}
					];
					
					activity[ key ].forEach(
						( point, index ) => {
							points.push(
								{
									"xAct": scaleXActivity( parseInt( point.activity, 10 ) ),
									"xPop": scaleXPopularity( parseInt( point.popularity, 10 ) ),
									"y": scaleY( parseInt( point.timestamp, 10 ) )
								}
							);
						}
					);
					
					let mirror = [];
					points.forEach(
						( point ) => {
							mirror.push({
								"xAct": (boundaries.center + ( boundaries.center - point.xAct )),
								"xPop": (boundaries.center + ( boundaries.center - point.xPop )),
								"y": point.y,
							});
						}
					);
					
					mirror.reverse();
					points = points.concat( mirror );
			
					const activityArea = d3.area()
						.x( points => points.xAct )
						.y1( points => points.y )
						.curve( d3.curveBasis );
					
					const popularityArea = d3.area()
						.x( points => points.xPop )
						.y1( points => points.y )
						.curve( d3.curveBasis );
					
					
					curves.push(
						{
							"activityPath": activityArea( points ),
							"name": parties[key],
							"popularityPath": popularityArea( points ),
							"slug": key,
							"style":{
								"left": boundaries.center + 'px'
							}
						}
					)
					debug.push( points );
				}
			);
		}	
		var milestones = [];
		if ( this.state.milestones.length > 0 ) {
			let pm = 0;
			for( let i=0, l =this.state.milestones.length; i<l; i++ ) {
				
				if ( this.state.milestones[i].timestamp_published >= news[ ( news.length - 1 ) ].date_published_timestamp &&
		        	this.state.milestones[i].timestamp_published <= news[0].date_published_timestamp ) {
			        
			        let milestone = this.state.milestones[i];
					milestone.top = scaleY( milestone.timestamp_order );
					if ( pm === milestone.timestamp_order ) {
						milestone.position = 2;
					} else {
						milestone.position = 1;
					}
					pm = milestone.timestamp_order;
					milestones.push( milestone );
				    
				}
		    }
		}
		
		let paths = {
			"date_lines": lines,
			"curves": curves
		}
				
		this.setState( { "articles": news, "debug": debug, "milestones": milestones, "paths": paths } );
	}
	
	setMax( log ) {
		let activity = this.state.activity;
	
		let max_values = {
				"activity": -1,
				"popularity": -1
			};
		
		
		Object.keys( activity ).forEach(
			function( key, index ) {
				activity[ key ].forEach(
					function( day ) {
						if ( max_values.activity < parseInt( day.activity, 10 ) ) {
							max_values.activity = parseInt( day.activity, 10 );
						}
						if ( max_values.popularity < parseInt( day.popularity, 10 ) ) {
							max_values.popularity = parseInt( day.popularity, 10 );
						}
					}
				)
    		}
    	);
		
		
		this.setState( { "max_values": max_values }, () => { this.viewbox(); } );
	}
	
	viewbox() {
		let width = this.chart.current.offsetWidth;
		let size = {
			"w": width,
			"h": ( this.state.articles ) ? ( ( this.state.articles.length * this.state.articleHeight ) + this.state.borders ) : document.querySelector( '#timeline-page' ).offsetHeight
		};
		this.setState( { 'enabled': ( ( width >= this.state.min_width ) ? true : false ), 'size': size }, () => { this.draw(); } );
	}
	
	writeMarkup() {
		if ( this.state.enabled ) {
			return <div className="timeline--page--viz" style={{ "height": this.state.size.h + "px" }}>
				<div className="in">
					<div className="timeline--page--viz--articles" id="timeline--page--viz--articles">
						{
							this.state.articles.map(
								( article ) => {
									return (
										<article key={article.id} className="timeline-page--articles--article" style={{ "top": article.top + "px" }}>
											<ul className="timeline-page--articles--article--collections">
												{
													article.collections.map(
														( collection, index ) => {
															return <li key={collection.slug + collection.id + index}><a href={"#/categoria/" + collection.slug} title={collection.name} className={collection.slug}><span>{collection.name}</span></a></li>;
														}
													)
												}
											</ul>
											<h4>{article.date_published_short}</h4>
											<h2><a target="_read" href={article.url} title={article.title} className="timeline-page--viz--articles--article--link">{this.abstract( article.title )} ({article.source})</a></h2>
										</article>
									);
								}
							)
						}
					</div>
					<div className="timeline--page--viz--legend" id="timeline--page--viz--legend">
						<div className="in">
							<div className="party-title articles">
								<h2>Articoli più popolari di ogni giorno</h2>
							</div>
							{
								this.state.paths.curves.map(
									( curve, index ) => {
										return (
											<div key={ "T-" + index } className={"party-title " + curve.slug} style={curve.style}>
												<h2>{curve.name}</h2>
												<span className="activity">Att. </span>
												<span className="popularity">Pop. </span>
											</div>
										)
									}
								)
							}
						</div>
					</div>
					<svg id="timeline-page--viz--svg" className="timeline-page--viz--svg" width={this.state.size.w} height={this.state.size.h} preserveAspectRatio="xMidYMid meet" viewBox={"0 0 " + this.state.size.w + " " + this.state.size.h}>
						<g className="timeline-page--viz--svg--curves">
						{
							this.state.paths.curves.map(
								( curve, index ) => {
									return (
										<g  key={"PT-" + index} className={curve.slug}>
											 <path d={curve.activityPath} className="timeline-page--viz--svg--curve-activity" />
											 <path d={curve.popularityPath} className="timeline-page--viz--svg--curve-popularity" />
										</g>
									)
								}
							)
						}
						</g>
						<g className="timeline-page--viz--svg--date-lines">
						{
							this.state.paths.date_lines.map(
								( line, index ) => {
									return <line key={"LN-" + index} x1="0" y1={line.y} x2={this.state.size.w} y2={line.y} className="timeline-page--viz--svg--date-line" />
								}
							)
						}
						</g>
					</svg>
				</div>
			</div>;
		} else {
			return <p><strong>Questa visualizzazione richiede uno schermo grande. Su molti smartphone, è sufficiente ruotare il telefono in posizione orizzontale per poter vedere correttamente la timeline.</strong></p>
		}
	}
	
	render() {
		return (
			<div className="timeline in">
        <div className="timeline--legend">
          <div className="timeline--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h1>La Timeline</h1>
              </div>
              <div className="item--text--body">
                <div>
								<p>Cerchiamo infine di raccontare queste elezioni tramite la loro timeline, mostrando sia l'attività quotidiana per ogni schieramento che la popolarità (calcolata basandosi sulle condivisioni Twitter e Facebook) dei vari articoli.</p>
								<p>Nella prima colonna a sinistra, assieme al calendario, è mostrato l'articolo più popolare tra quelli importati quel giorno. Ogni altra colonna rappresenta uno schieramento composto secondo il nostro solito standard: Destra <span className="color destra"></span>, Centro Destra <span className="color centro-destra"></span>, Movimento 5 Stelle <span className="color m5s"></span>, Centro Sinistra <span className="color centro-sinistra"></span>, e Sinistra <span className="color sinistra"></span>. L'area grigia rappresenta il numero di articoli pubblicati che parlano di quello schieramento, l'area colorata rappresenta l'attività sui social network degli stessi articoli (tweets, retweets, like, condivisioni, commenti, ecc.).</p>
                </div>
              </div>
            </div>
          </div>
        </div>
				<div className="timeline--data" ref={this.chart}>
				{this.writeMarkup()}
				</div>
			</div>
		);
	}
}

export default DTimeline;


// WEBPACK FOOTER //
// ./src/Elezioni/dataviz/timeline.js